import { render, staticRenderFns } from "./DetectMobile.vue?vue&type=template&id=792c1a8e"
import script from "./DetectMobile.vue?vue&type=script&lang=js"
export * from "./DetectMobile.vue?vue&type=script&lang=js"
import style0 from "./DetectMobile.vue?vue&type=style&index=0&id=792c1a8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports